(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawli-single-product-home"] && !Shopify.designMode) return;
  try {
    (function(){var box=document.querySelector('.pawli-home__countdown');if(!box)return;var end=new Date(box.dataset.end).getTime();function tick(){var d=Math.max(0,end-Date.now()),s=Math.floor(d/1000),days=Math.floor(s/86400),hours=Math.floor(s%86400/3600),mins=Math.floor(s%3600/60),secs=s%60;box.querySelector('[data-days]').textContent=String(days).padStart(2,'0');box.querySelector('[data-hours]').textContent=String(hours).padStart(2,'0');box.querySelector('[data-minutes]').textContent=String(mins).padStart(2,'0');box.querySelector('[data-seconds]').textContent=String(secs).padStart(2,'0');if(d<=0)box.querySelector('strong').textContent='Oferta de lanzamiento finalizada';}tick();setInterval(tick,1000);})();
  } catch(e) { console.error(e); }
})();
})();
